import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Optional,
  Inject,
  ElementRef,
  ViewChild,
  OnChanges,
} from '@angular/core';
import { ActivityService } from '../../../core/services/activity.service';
import { FileService } from '../../../core/services/file.service';
import { HrPanelInterviewObj, HrPanelInterviewActivity } from '../../../shared/models/activity-dashboard-model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivityDialogComponent } from 'src/app/modules/activities/activity-dialog/activity-dialog.component';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-coupled-hrpanel-interview-activity',
  templateUrl: './coupled-hrpanel-interview-activity.component.html',
  styleUrls: ['./coupled-hrpanel-interview-activity.component.scss'],
  standalone: false,
})
export class CoupledHrpanelInterviewActivityComponent implements OnInit, OnChanges {
  public isCollapsed: boolean = false;
  //time
  public timeModifiedOn: string;
  @Input() checkHrPanelInterviewObj: HrPanelInterviewObj;
  @Input() candidateApplicationIds: number[];
  @Input() ifCoupled: boolean;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();
  @Output() coupledformValid: EventEmitter<boolean> = new EventEmitter();
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  multiple = 'multipleSelect';

  single = 'single';
  toggleBtn: boolean = false;
  referenceActivities: any[];
  inputVal: any;
  referenceId: any;
  empNo: any;
  hractivity: boolean = true;
  editactivity: boolean = false;
  remarks: any;
  refrenceindex: number;
  fileData: any;
  deletedFile: any;
  editId: any;
  companyHiringType: any; //= 1;
  userloggedin: any;
  loginUserName: any;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = false;
  separatorKeysCodes = [ENTER, COMMA];
  empInputCtrl = new UntypedFormControl();
  filteredEmp = [];
  empList = [];
  disableSend = true;
  loader: boolean = false;
  hrEmpNo;
  savePanelData;
  inputCtrl = new UntypedFormControl();
  placeHold = 'HR Employee Number*';
  @ViewChild('empInput') empInput: ElementRef;
  roleControl = new UntypedFormControl();
  roles: any[] = [];
  filteredRoles: Observable<any[]>;
  selectedJobSubLevel: string = '';
  onEdit: boolean;

  constructor(
    private hrInterviewService: ActivityService,
    private fileService: FileService,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.checkHrPanelInterviewObj = data.checkHrPanelInterviewObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
    }
  }

  ngOnChanges() {
    this.referenceId = -1;
    this.empNo = '';
    this.remarks = '';
  }

  ngOnInit() {
    this.companyHiringType = localStorage.getItem('fresherCompHiringTypeId');

    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);

    this.loginUserName = this.userloggedin.username;
    console.log(this.loginUserName);

    console.log(this.checkHrPanelInterviewObj);
    this.referenceId = -1;
    this.empNo = '';
    this.remarks = '';
    this.hrEmpNo = '';
    // this.editId = { objectId: this.checkHrPanelInterviewObj.applicationId, objectType: 'AP' };

    this.hractivity = this.checkHrPanelInterviewObj.isHrActivity;
    console.log('inside hr component', this.hractivity);
    if (!this.hractivity) {
      this.placeHold = 'Panel Employee Number*';
    }
    this.hrInterviewService.getReferenceActivity().subscribe((res) => {
      if (res.length > 0) {
        this.referenceActivities = res;
      }
    });
    this.hrInterviewService.getRoles().subscribe((res) => {
      if (res.length > 0) {
        this.roles = res;
        this.filteredRoles = this.roleControl.valueChanges.pipe(
          startWith(''),
          map((value) => this.filterRoles(value)),
        );
      }
      this.roleControl.valueChanges.subscribe((val) => {
        if (!val) {
          this.selectedJobSubLevel = '';
        }
      });
    });
    if (this.editactivity) {
      this.editId = {
        objectId: this.checkHrPanelInterviewObj.applicationId,
        objectType: 'AP',
        activityId: this.checkHrPanelInterviewObj.activityId,
      };
      this.disableSend = false;
      this.getHrPanelActivity(this.checkHrPanelInterviewObj);
    }
    // this.showMoreLess();
    this.inputCtrl.valueChanges.subscribe((val) => {
      this.filteredEmp = [];
      if (typeof val === 'string' && val.length > 3 && this.companyHiringType == 1) {
        // this.ngxLoader.start();
        this.hrInterviewService.getHrDetail(val).subscribe((response) => {
          if (response.empId != null) {
            this.filteredEmp.push(response);
          }
          // this.ngxLoader.stop();
          console.log('filteredlist--', this.filteredEmp);
        });
      }
    });
  }

  filterRoles(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.roles.filter((role) => role.roleCapDesc.toLowerCase().includes(filterValue));
  }

  validateForm() {
    if (this.inputVal.length >= 1) {
      this.disableSend = false;
    } else {
      this.disableSend = true;
    }
  }
  getSelectedEmp() {
    const empIdList = [];
    this.empList.forEach((item) => {
      empIdList.push(item.empId);
    });
    return empIdList.join(',');
  }
  add(event: MatChipInputEvent): void {
    const input = event.input;
    // Add our fruit
    // if ((value || '').trim()) {
    //   this.empList.push(value.trim());
    // }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.empInputCtrl.setValue(null);
  }

  remove(empItem: any): void {
    console.log(empItem.empNo);
    const index = this.empList.indexOf(empItem);
    if (index >= 0) {
      this.empList.splice(index, 1);
    }
    this.inputVal = this.getSelectedEmp();
    this.validateForm();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.empList.push(event.option.value);
    this.empInput.nativeElement.value = '';
    this.empInputCtrl.setValue(null);
  }
  testformValid(flag) {
    console.log('couple form valid');
    this.coupledformValid.emit(flag);
  }

  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }
  validateId() {
    // this.empList.push({empName: this.hrEmpNo});
    // this.empList.push({empName: this.hrEmpNo});
    console.log(this.empList);
    console.log(this.hrEmpNo);
    // this.ngxLoader.start();
    this.loader = true;
    this.hrInterviewService
      .getSupportTeamMember(this.hrEmpNo, this.checkHrPanelInterviewObj.applicationId)
      .subscribe((response) => {
        this.savePanelData = response;
        if (this.savePanelData.isEligible == 'Y') {
          console.log(response);
          console.log(response.responseModel.empName);
          this.empList.push(response.responseModel);
          // this.ngxLoader.stop();
          this.loader = false;
          this.inputVal = this.getSelectedEmp();
          //this.filteredEmp.push(response.responseModel);
          console.log(this.empList);
          console.log(this.inputVal);
          this.validateForm();
        } else {
          const data = {
            msg: response.statusMessage,
            isSuccess: false,
          };
          this.hrInterviewService.openSnackBar(data, 'danger-snack');
        }
      });
    this.hrEmpNo = '';
  }
  send() {
    const obj: HrPanelInterviewActivity = {
      applicationListId: this.candidateApplicationIds,
      activityId: this.checkHrPanelInterviewObj.activityId,
      processId: this.checkHrPanelInterviewObj.processId,
      remarks: this.remarks,
      seqId: -1,
      confirmationResults: this.referenceId,
      roles: this.roleControl.value,
      jobSubLevel: this.selectedJobSubLevel,
    };
    if (this.hractivity) {
      obj.addHr = this.inputVal;
      obj.addPanelist = null;
    } else {
      obj.addPanelist = this.inputVal;
      obj.addHr = null;
    }
    console.log('object created', obj);

    if (this.editactivity) {
      obj.seqId = this.checkHrPanelInterviewObj.hrpanelactivity.seqId;
      // obj.createdBy=this.checkHrPanelInterviewObj.createdOn;
      // obj.createdBy=this.checkHrPanelInterviewObj.createdBy;
      this.editHrPanelInterviewActivity(obj);
    } else {
      this.saveHrPanelInterviewActivity(obj);
    }

    // this.refreshcandiates.emit("true");
  }
  saveHrPanelInterviewActivity(obj: HrPanelInterviewActivity) {
    console.log('inside savehr method');
    this.hrInterviewService.saveEditHrPanelInterview(obj).subscribe(
      (res) => {
        console.log('response', res);
        if (res.error && res.error.toLowerCase() === 'failure') {
          const data = {
            msg: res.message,
            isSuccess: 'error',
          };

          console.log(data);
          this.hrInterviewService.openSnackBar(data, 'danger-snack');
        } else {
          this.saveAttachment(this.checkHrPanelInterviewObj.applicationId, this.companyHiringType);

          const data = {
            msg: res.message,
            isSuccess: 'created',
          };
          this.hrInterviewService.openSnackBar(data, 'success-snack');
          this.refreshcandiates.emit('true');
        }
      },
      (err) => {
        console.log(err);
        const data = {
          msg: 'Some error Occurred',
          isSuccess: false,
        };

        this.hrInterviewService.openSnackBar(data, 'danger-snack');
      },
    );
  }
  editHrPanelInterviewActivity(obj: HrPanelInterviewActivity) {
    console.log('inside edit method');
    this.hrInterviewService.saveEditHrPanelInterview(obj).subscribe(
      (res) => {
        console.log('response', res);
        this.saveAttachment(this.checkHrPanelInterviewObj.applicationId, this.companyHiringType);

        const data = {
          msg: 'Data Updated Successfully !!!',
          isSuccess: true,
        };

        this.hrInterviewService.openSnackBar(data, 'success-snack');
      },
      (_err) => {
        const data = {
          msg: 'Some error Occurred',
          isSuccess: false,
        };

        this.hrInterviewService.openSnackBar(data, 'danger-snack');
      },
    );
    this.dialogRef.close();
  }

  getHrPanelActivity(obj: HrPanelInterviewObj) {
    // obj.createdOn
    this.hrInterviewService.getHrPanelActivity(obj.applicationId, obj.activityId, obj.createdOn).subscribe((res) => {
      console.log(res);
      this.checkHrPanelInterviewObj.hrpanelactivity = res[0];
      this.dataInitialization(res[0]);
      if (res[0].seqId > 0) {
        this.onEdit = true;
      }
    });
  }
  dataInitialization(hrpanelObj: HrPanelInterviewActivity) {
    if (hrpanelObj == null) {
      this.remarks = '';
    } else {
      console.log('hr[panelobj', hrpanelObj);
      this.remarks = hrpanelObj.remarks;
      this.roleControl.setValue(hrpanelObj.roles);
      this.selectedJobSubLevel = hrpanelObj.jobSubLevel;
      if (hrpanelObj.addHr !== null) {
        this.empList = [];
        const hrarray = hrpanelObj.addHr.split(',');
        console.log('hrarray', hrarray);
        // this.ngxLoader.start();
        this.loader = true;
        hrarray.forEach((item) => {
          this.hrInterviewService.getHrDetail(item).subscribe((resp) => {
            this.empList.push(resp);
            // this.ngxLoader.stop();
            this.loader = false;
          });
          this.empNo = hrpanelObj.addHr;
        });

        // this.hrInterviewService.getHrDetail(hrpanelObj.addHr).subscribe(resp=>{
        //   this.empList.push(resp);
        // })
        // this.empNo = hrpanelObj.addHr;
      } else {
        this.empList = [];
        const hrarray = hrpanelObj.addPanelist.split(',');
        // this.ngxLoader.start();
        this.loader = true;
        hrarray.forEach((item) => {
          this.hrInterviewService.getHrDetail(item).subscribe((resp) => {
            this.empList.push(resp);
            // this.ngxLoader.stop();
            this.loader = false;
          });
          this.empNo = hrpanelObj.addPanelist;
        });
      }
      console.log('edit emplist---', this.empList);
      this.referenceId = hrpanelObj.confirmationResults;
    }
  }

  receiveFileOutput(filedata) {
    console.log('inside recievefile format');
    this.fileData = filedata['fileMerge1'];
    this.deletedFile = filedata['deletedFile1'];
    console.log(this.fileData);
    console.log(this.deletedFile);
  }

  saveAttachment(genericId, companyHiringTypeId) {
    console.log('inside saveattachmnt suitability');
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.hrInterviewService.openSnackBar(data, 'danger-snack');
          },
        );
      });
    }
    const activityId: any = this.checkHrPanelInterviewObj.activityId;
    const fdChr_ = new FormData();
    fdChr_.append('objectId', genericId);
    fdChr_.append('objectType', 'AP');
    fdChr_.append('attachmentId', '2');
    fdChr_.append('companyHiringTypeId', companyHiringTypeId);
    fdChr_.append('activityId', activityId);
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        fdChr_.append('file[' + file.name + ']', file);
      });
      console.log(fdChr_);
      this.fileService.upload(fdChr_).subscribe(
        (_res) => {},
        (_err) => {},
      );
    }
  }
}
